/**
 * src/api/functionUrl.js
 *
 * Returns the full URL for calling an Azure Function by name.
 *
 * Azure: https://seasuite-func-prod-xxx.azurewebsites.net/api/{name}
 */

const AZURE_URL = import.meta.env.VITE_AZURE_FUNCTIONS_URL;

/**
 * Get the full URL for an Azure Function by name.
 * @param {string} name — e.g. 'tenant-login', 'create-bug-issue'
 */
export function getFunctionUrl(name) {
  return `${AZURE_URL}/api/${name}`;
}
